import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=e34a5d30"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/卡百利业务中台2.0（前端）生产环境/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e34a5d30')) {
      api.createRecord('e34a5d30', component.options)
    } else {
      api.reload('e34a5d30', component.options)
    }
    module.hot.accept("./EmptyLayout.vue?vue&type=template&id=e34a5d30", function () {
      api.rerender('e34a5d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/EmptyLayout.vue"
export default component.exports